export interface EcomSettings {
  ecomEnabled: boolean;
}

export interface SfccSettings {
  currency: string;
  shopApiBaseUrl: string;
  sfccBaseUrl: string;
  shopApiClientId: string;
  shopApiLocale: string;
  basketCheckoutUrl: string;
  basketSiteId: string;
  productSearchApiClientId: string;
  productSearchApiUrl: string;
}

export interface DisplaySettings {
  priceDisplayOption: PriceDisplayOption;
  priceDisplayThreshold: null;
}

export interface MyJabraSettings {
  baseUrl: string;
}

export const enum SiteSettingsScope {
  Cart = 'cart',
  Display = 'display',
  Ecom = 'ecom',
  Sfcc = 'sfcc',
  Authorization = 'authorization',
  MyJabra = 'myjabra',
  Shipping = 'shipping',
  Returns = 'returns',
}

export const enum PriceDisplayOption {
  ExcludeIncludeVAT = 'ExcludeIncludeVAT',
  IncludesVATLabel = 'IncludesVATLabel',
  ExcludeVATThreshold = 'ExcludeVATThreshold',
  Simple = 'Simple',
}

export const SiteFeature: Record<string, keyof FeaturesSettings> = {
  SfccBasket: 'SfccBasket',
  SfccBasketEngraving: 'SfccBasketEngraving',
  SfccBasketLocationWarning: 'SfccBasketLocationWarning',
  SfccBasketSendByEmail: 'SfccBasketSendByEmail',
  SfccBasketShippingMessage: 'SfccBasketShippingMessage',
  SfccPrice: 'SfccPrice',
  SfccBasketGiftWrapping: 'SfccBasketGiftWrapping',
  SfccSearch: 'SfccSearch',
  BasketUipEnabled: 'BasketUipEnabled',
  TopMenuUipEnabled: 'TopMenuUipEnabled',
  TopMenuMyJabraEnabled: 'TopMenuMyJabraEnabled',
  ProductVisualizationRendering: 'ProductVisualizationRendering',
  Klarna: 'Klarna',
};

export interface FeaturesSettings {
  SfccBasket?: boolean;
  SfccBasketEngraving?: boolean;
  SfccBasketLocationWarning?: boolean;
  SfccBasketSendByEmail?: boolean;
  SfccBasketShippingMessage?: boolean;
  SfccPrice?: boolean;
  SfccBasketGiftWrapping?: boolean;
  SfccSearch?: boolean;
  BasketUipEnabled?: boolean;
  TopMenuUipEnabled?: boolean;
  TopMenuMyJabraEnabled?: boolean;
  ProductVisualizationRendering?: boolean;
  Klarna?: boolean;
}

export type FeatureList = {
  name: string;
  value: boolean;
}[];
